<!-- @format -->

<template>
  <canvas id="canvas"></canvas>
</template>

<script setup>
import { onMounted } from 'vue'
const props = defineProps({
  progressColor: {
    type: String,
    default: 'green',
  },
  strokeWidth: {
    type: Number,
    default: 4,
  },
})
onMounted(() => {
  let canvas = document.querySelector('#canvas')
  canvas.width = canvas.clientWidth
  canvas.height = canvas.clientHeight
  let x = canvas.clientWidth / 2
  let y = canvas.clientHeight / 2
  var ctx = canvas.getContext('2d')
  ctx.imageSmoothingEnabled = false
  // ctx.translate(0.5, 0.5);
  ctx.lineWidth = props.strokeWidth
  ctx.strokeStyle = props.progressColor
  ctx.beginPath()
  var radius = (0.85 * canvas.clientWidth) / 2 // 圆弧半径
  var startAngle = 0 // 开始点
  var endAngle = startAngle + 0.95 * 2 * Math.PI // 结束点
  ctx.arc(x, y, radius, startAngle, endAngle, false)
  ctx.stroke()
})
</script>
<style scoped>
#canvas {
  border-radius: 50%;
  animation: 0.56s linear infinite rotate;
  transition: background-color 2s;
}
#canvas:hover {
  background-color: aqua;
}
@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
</style>
